import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectIsPurchasePointsEventRunning } from "../../../selectors/selectPurchasePointsEventInfo";
import { FontWithOutline } from "../../generic/font-with-outline/FontWithOutline";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../../generic/number-format/TypeNumberFormat";
export var _OfferBadgePurchasePoints = function (_a) {
    var purchasePoints = _a.purchasePoints, shouldRender = _a.shouldRender, _b = _a.className, className = _b === void 0 ? "" : _b;
    if (!shouldRender || purchasePoints == undefined) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: IdStyles.PurchasePointsBig + " " + className + " flex flex--aligned flex--stacked" },
        React.createElement("div", { className: "pt__medium" },
            React.createElement(Icon, { icon: IdIcon.PointsIcn, styleId: IdStyles.IconSmall })),
        React.createElement("div", { className: "offer-body__purchase-points-badge_amount" },
            React.createElement(FontWithOutline, { style: IdStyles.TextBoldSecondaryOutline },
                React.createElement(NumberFormat, { amount: purchasePoints, format: TypeNumberFormat.Add })))));
};
var mapState = function (state) { return ({
    shouldRender: selectIsPurchasePointsEventRunning(state),
}); };
export var OfferBadgePurchasePoints = connect(mapState)(_OfferBadgePurchasePoints);



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferBadgePurchasePoints.tsx
// module id = 958
// module chunks = 3